/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MoveFolderItemDto interface.
 */
export function instanceOfMoveFolderItemDto(value) {
    if (!('folderId' in value) || value['folderId'] === undefined)
        return false;
    if (!('newName' in value) || value['newName'] === undefined)
        return false;
    return true;
}
export function MoveFolderItemDtoFromJSON(json) {
    return MoveFolderItemDtoFromJSONTyped(json, false);
}
export function MoveFolderItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'folderId': json['folderId'],
        'newName': json['newName'],
    };
}
export function MoveFolderItemDtoToJSON(json) {
    return MoveFolderItemDtoToJSONTyped(json, false);
}
export function MoveFolderItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'folderId': value['folderId'],
        'newName': value['newName'],
    };
}
